// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearSaveAdd = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.6664 5.99325V13.5666C10.6664 14.5333 9.97304 14.94 9.12637 14.4733L6.50637 13.0133C6.22637 12.8599 5.77302 12.8599 5.49302 13.0133L2.87301 14.4733C2.02634 14.94 1.33301 14.5333 1.33301 13.5666V5.99325C1.33301 4.85325 2.26633 3.91992 3.40634 3.91992H8.59305C9.73305 3.91992 10.6664 4.85325 10.6664 5.99325Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.6664 3.40683V10.9802C14.6664 11.9469 13.973 12.3535 13.1264 11.8869L10.6664 10.5135V5.99351C10.6664 4.8535 9.73303 3.92018 8.59303 3.92018H5.33301V3.40683C5.33301 2.26682 6.26633 1.3335 7.40634 1.3335H12.593C13.733 1.3335 14.6664 2.26682 14.6664 3.40683Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.66699 8H7.33367',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6 9.33318V6.6665',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconLinearSaveAdd };
